export default "/_next/static/images/dr-georgia-jeremiah-1a0eb259f2bd0791bb3c97221ec41bbd.png";